import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

Sentry.init({
	dsn: "https://478eedbab39520791a94a0569731a964@o4509084678422528.ingest.us.sentry.io/4509084681502720"
});

bootstrapApplication(AppComponent, appConfig)
  	.catch((err) => console.error(err));
